import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { AppBar, Paper, Tabs as UITabs, Tab as UITab } from '@material-ui/core'

function Tabs({ classes, tabs, selected, onChange, children }) {

  const renderTabs = () => {
    return tabs.map((t, i) => (
      <UITab
        key={i}
        label={t}
        value={i}
        className={classes.customTab}
        style={{
          color: selected === i ? null : 'white',
          fontWeight: selected === i ? 'bold' : 'normal',
          fontSize: 'large'
        }}
      />
    ))
  }

  if (!tabs.length)
    return null

  return (
    <>
      <AppBar position='static' className={classes.appBar}>
        <UITabs
          value={selected}
          onChange={(_, tabVal) => onChange(tabVal)}
          textColor='primary'
          indicatorColor='primary'
          variant="scrollable"
          scrollButtons="auto"
        >
          {renderTabs()}
        </UITabs>
      </AppBar>
      <Paper square elevation={3} className={classes.content}>
        {children}
      </Paper>
    </>
  )
}

Tabs.propTypes = {
  tabs: PropTypes.array,
  selected: PropTypes.number,
  onChange: PropTypes.func,
}

Tabs.defaultProps = {
  tabs: [],
  selected: 0,
  onChange: () => true
}

const styles = theme => ({
  appBar: {
    background: theme.palette.background.shade01
  },
  content: {
    minWidth: 'fit-content',
    padding: theme.spacing(3),
  },
  customTab: {
    borderRight: `2px solid ${theme.palette.background.shade02}`
  }
})

export default withStyles(styles)(Tabs)